// intercomのヘルプページURLが長くJSX内にベタ書きすると可読性が落ちるので定数化

// Q.半年・年間定額プランを契約中ですが、プランをアップグレードしたいです。
export const UPGRADE_PAGE_URL =
  'https://intercom.help/plus---samurai/ja/articles/6360651-q-%E5%8D%8A%E5%B9%B4-%E5%B9%B4%E9%96%93%E5%AE%9A%E9%A1%8D%E3%83%97%E3%83%A9%E3%83%B3%E3%82%92%E5%A5%91%E7%B4%84%E4%B8%AD%E3%81%A7%E3%81%99%E3%81%8C-%E3%83%97%E3%83%A9%E3%83%B3%E3%82%92%E3%82%A2%E3%83%83%E3%83%97%E3%82%B0%E3%83%AC%E3%83%BC%E3%83%89%E3%81%97%E3%81%9F%E3%81%84%E3%81%A7%E3%81%99';
